<template>
    <div style="overflow: auto">
        <div class="mb-4">
            <input type="text" v-model="search" class="form-control form-control-lg shadow-sm" placeholder="Cerca assistito o Codice..." />
        </div>
        <div v-for="pratica in praticheFiltrate" :key="pratica.numeroPratica" class="card sa-siat-card-pratica shadow-sm">
            <div class="sa-siat-card-header-custom">
                <b-row>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Pratica</div>
                        <small style="font-size: 1rem; color: #07077d; font-weight: bold">#{{ pratica.numeroPratica }}</small>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Stato</div>
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + pratica.stato.toLowerCase()">{{ pratica.stato }}</span>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Bisogno</div>
                        <span class="sa-siat-data" :class="'sa-siat-data-' + bisogno(pratica)">{{ pratica.bisogno }}</span>
                    </b-col>
                </b-row>
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Assistitoaa</div>
                        <div class="h5 mb-0 text-primary">{{ pratica.assistito.cognome }} {{ pratica.assistito.nome }}</div>
                        <small class="text-muted sa-siat-text-indirizzo"><i class="fas fa-map-marker-alt"></i> {{ pratica.assistito.indirizzoDiResidenza }}</small>
                    </div>
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Codice Fiscale</div>
                        <span class="sa-siat-data">{{ pratica.assistito.codiceFiscale }}</span>
                    </div>
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Distretto / Stato</div>
                        <div>{{ pratica.distretto.code }} - {{ pratica.distretto.descrizione }}</div>
                    </div>
                </div>
            </div>

            <div class="pb-3 pt-2 bg-light">
                <div class="px-4 mb-2 small font-weight-bold text-muted text-uppercase">Elenco Prestazioni Attive:</div>

                <div v-for="ev in pratica.eventi" :key="ev.numeroEvento">
                    <b-row class="sa-siat-row">
                        <b-col class="sa-siat-cols text-left" cols="12" md="4">
                            <div class="sa-siat-label-pai">Id Evento</div>
                            <div class="sa-siat-valore-pai">{{ ev.numeroEvento }}</div>
                        </b-col>
                        <b-col class="sa-siat-cols text-center" cols="12" md="4">
                            <div class="sa-siat-label-pai">Tipo</div>
                            <div class="sa-siat-valore-pai">{{ ev.tipo }}</div>
                        </b-col>
                        <b-col class="sa-siat-cols text-right" style="justify-content: end; display: flex" cols="12" md="4">
                            <div class="ml-auto text-right align-end">
                                <template v-if="ev.presaInCarico">
                                    <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-aperta'"
                                        >{{ ev.presaInCarico.esito }}
                                        <br class="m-1" />
                                        {{ formatDate(ev.presaInCarico.dataPresaInCarico) }}
                                    </span>
                                </template>
                                <template v-else>
                                    <b-button variant="outline-info btn-toolbar sa-margin-left float-sm-left" @click="onClickPrendiInCarico(ev)">
                                        <i class="fas fa-hand-holding-medical"></i>
                                        Conferma Lettura
                                    </b-button>
                                </template>
                                <!-- <template v-if="pratica.statoInterno === 'DA CONFERMARE'">
                                    <b-button variant="outline-info btn-toolbar sa-margin-left float-sm-left" @click="onClickConfermaLettura(ev)">
                                        <i class="fas fa-hand-holding-medical"></i>
                                        Conferma Lettura
                                    </b-button>
                                </template> -->
                            </div>
                        </b-col>
                    </b-row>

                    <div v-for="pres in ev.prestazioni" :key="pres.pacchettoCodice" class="sa-siat-prestazione-item shadow-xs" :class="'sa-siat-border-' + pres.figuraProfessionale.ra_cod">
                        <div class="sa-siat-prestazione-header" @click="togglePrestazione(pres.pacchettoCodice)">
                            <div>
                                <span class="badge badge-outline-secondary mr-2">{{ pres.figuraProfessionale.ra_cod }}</span>
                                <strong>{{ pres.tipoPrestazione.value }} ({{ pres.tipoPrestazione.pr_id }}) </strong>
                            </div>
                            <i class="fas text-muted" :class="isPresOpen(pres.pacchettoCodice) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        </div>

                        <div v-if="isPresOpen(pres.pacchettoCodice)" class="prestazione-detail">
                            <b-row class="sa-siat-row">
                                <b-col class="sa-siat-cols" cols="12" md="3">
                                    <div class="sa-siat-label-pai">Codice Pacchetto</div>
                                    <div class="sa-siat-valore-pai">{{ pres.pacchettoCodice }} - {{ pres.pacchettoDescrizione }}</div>
                                </b-col>
                                <b-col class="sa-siat-cols" cols="12" md="2">
                                    <div class="sa-siat-label-pai">Data Inizio Int.</div>
                                    <div class="sa-siat-valore-pai"><i class="far fa-calendar-alt mr-1"></i> {{ pulisciData(pres.dataInizioInterventi) }}</div>
                                </b-col>
                                <b-col class="sa-siat-cols text-right" cols="12" md="4">
                                    <div class="sa-siat-label-pai">Frequenza Pianificata</div>
                                    <div class="sa-siat-valore-pai">
                                        <i class="fas fa-history mr-1 text-info"></i>
                                        <template v-if="pres.frequenza"> {{ pres.frequenza.numeroInterventi }} int. / {{ pres.frequenza.numeroRipetizioni }} {{ pres.frequenza.utNumeroRipetizioni }} </template>
                                        <template v-else-if="pres.frequenzaVolte"> ogni {{ pres.frequenzaVolte.numeroGiorni }}gg per {{ pres.frequenzaVolte.numeroVolte }} volte </template>
                                        <span>(durata: {{ pres.durataPrevista }} min.)</span>
                                    </div>
                                </b-col>
                                <b-col class="sa-siat-cols text-right" cols="12" md="3">
                                    <div class="sa-siat-label-pai">Figura Professionale</div>
                                    <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ pres.figuraProfessionale.value }}</span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4">
                                <b-col class="sa-siat-cols" cols="4">
                                    <div class="sa-siat-label-pai">Operativita del Servizio</div>
                                    <div class="italic sa-siat-text-data">{{ pres.operativitaServizio }}</div>
                                </b-col>
                                <b-col class="sa-siat-cols text-center" cols="4">
                                    <small style="color: black">Codice PAI: <strong>PO_ID</strong> | IA_ID: IA_ID</small>
                                </b-col>
                                <b-col class="sa-siat-cols text-right" cols="4">
                                    <div class="sa-siat-label-pai">Livello Assistenza P.A.I.</div>
                                    <span class="badge justify-content-center badge-outline-primary border border-primary text-primary px-3" style="font-size: small">{{ pres.livelloAssistenzialePai }} </span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4">
                                <b-col class="sa-siat-cols" lg="12" xl="12">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <h5 class="mb-0 font-weight-bold text-left">Elenco Interventi</h5>
                                        <template
                                            ><!--v-if="pres.stato === 'INSERITO'"-->
                                            <b-button v-if="pres.listaEventiPrestazioniIntervallo.length > 0 && pratica.stato !== 'Chiusa'" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickConfermaPainificazione(ev)">
                                                <i class="fas fa-hospital"></i>
                                                Rendiconta
                                            </b-button>
                                        </template>
                                        <!-- <template v-else>
                                            <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-aperta'"
                                                >{{ pres.stato }}
                                                <br class="m-1" />
                                                {{ formatDate(pres.updateDate) }}
                                            </span>
                                        </template> -->
                                    </div>
                                    <template v-if="pres.listaEventiPrestazioniIntervallo.length > 0">
                                        <b-table sticky-header ref="table" stacked="xl" striped hover :items="pres.listaEventiPrestazioniIntervallo" :fields="fields" :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
                                            <template #cell(stato)="row">
                                                <span class="badge badge-pill badge-light border sa-siat-badge"> {{ row.item.stato }}</span>
                                            </template>
                                            <template #cell(actions)="row">
                                                <!--&& pratica.stato === 'Aperta'-->
                                                <b-button v-if="row.item.statoIntervento === 'PROGRAMMATO' && pratica.stato === 'Aperta'" v-b-tooltip.hover size="sm" variant="outline-success" title="Esegui" @click="onClickEsegui(row.item, $event.target)" class="mr-1 no-text">
                                                    <font-awesome-icon icon="edit"></font-awesome-icon>
                                                </b-button>
                                                <b-button v-if="row.item.statoIntervento === 'ESEGUITO' && pratica.stato === 'Aperta'" v-b-tooltip.hover variant="outline-purple" title="Rendiconta" @click="onClickConfermaPainificazione(ev, row.item)">
                                                    <i class="fas fa-hospital"></i>
                                                </b-button>
                                            </template>
                                        </b-table>
                                    </template>
                                    <template v-else>
                                        <no-data-component ref="cmpNoDataComponent" title="Nessun Intervento da pianificare" :fontSize="15" :paddingSize="0.5" nome="no-data" />
                                    </template>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="mdlEsegui" id="mdlEsegui" size="xl" style="height: 100%" @ok="onOkEseguiAttivita" @cancel="onCancelEseguiAttivita" title="Gestione Dizionario">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div class="sa-siat-label-pai">Numero Intervento</div>
                    <div>{{ attivitaSelezionata.numeroIntervento }}</div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div class="sa-siat-label-pai">Data Prevista</div>
                    <div>{{ formatDate(attivitaSelezionata.dataPrevista) }}</div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div class="sa-siat-label-pai">Ora Prevista</div>
                    <div>{{ attivitaSelezionata.oraPrevista }}</div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <div class="sa-siat-label-pai">Data/Ora Effettiva</div>
                    <date-picker disabled format="DD/MM/YYYY hh:mm" value-type="timestamp" v-model="attivitaSelezionata.dataEffettiva" type="datetime"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <div class="sa-siat-label-pai">Data/Ora Esecuzione</div>
                    <date-picker format="DD/MM/YYYY hh:mm" value-type="timestamp" v-model="attivitaSelezionata.dataEffettivaEsecuzione" type="datetime"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <div class="sa-siat-label-pai">Note</div>
                    <b-form-textarea id="textarea-no-resize" v-model="attivitaSelezionata.note" placeholder="Inserisci Note" rows="3" no-resize></b-form-textarea>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import SiatMixin from "../mixins/SiatMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import DatePicker from "vue2-datepicker";

export default {
    components: { NoDataComponent, DatePicker },
    mixins: [SiatMixin, UtilityMixin],
    data() {
        return {
            pathResource: "/siateventiprestazioniintevalli",
            attivitaSelezionata: {},
            fields: [
                {
                    label: "Numero Intervento",
                    key: "numeroIntervento",
                    sortable: false,
                },
                {
                    label: "Data Prevista",
                    key: "dataPrevista",
                    sortable: false,
                    formatter: (value) => {
                        if (!value) {
                            return "--";
                        } else {
                            return this.formatDate(value);
                        }
                    },
                },
                {
                    label: "Ora Prevista",
                    key: "oraPrevista",
                    sortable: false,
                },
                {
                    label: "Data Effettiva",
                    key: "dataEffettiva",
                    sortable: false,
                    formatter: (value) => {
                        if (!value) {
                            return "--";
                        } else {
                            return this.formatDate(value);
                        }
                    },
                },
                {
                    label: "Stato",
                    key: "statoIntervento",
                    sortable: false,
                },
                {
                    label: "",
                    key: "actions",
                    tdClass: "sa-table-column-action-double",
                },
            ],
        };
    },
    computed: {
        praticheFiltrate() {
            return this.pratiche.filter((p) => p.assistito.cognome.toLowerCase().includes(this.search.toLowerCase()) || p.assistito.codiceFiscale.toLowerCase().includes(this.search.toLowerCase()));
        },
    },
    methods: {
        bisogno(pratica) {
            return pratica?.bisogno?.toLowerCase();
        },
        loadData() {
            this.siatLoadLetturaPianiAssegnati();
        },
        togglePrestazione(pi_id) {
            const index = this.openPrestazioni.indexOf(pi_id);
            if (index > -1) {
                this.openPrestazioni.splice(index, 1);
            } else {
                this.openPrestazioni.push(pi_id);
            }
        },
        isPresOpen(pi_id) {
            return this.openPrestazioni.includes(pi_id);
        },
        pulisciData(d) {
            //return d ? d.split("+")[0] : "-";
            return this.formatDate(d);
        },
        effettuaPresa(item) {
            this.siatConfermaLettura(item);
        },
        onClickPrendiInCarico(item) {
            this.siatConfermaLettura(item);
        },
        onClickConfermaLettura(item) {
            this.siatConfermaLetturaAggiornamento(item);
        },
        onClickConfermaInterventiEvento(ev) {
            console.log(ev);
        },
        onClickEsegui(item) {
            let me = this;
            me.attivitaSelezionata = item;
            me.attivitaSelezionata.dataEffettiva = new Date().getTime();
            me.attivitaSelezionata.dataEffettivaEsecuzione = new Date().getTime();
            this.$refs.mdlEsegui.show();
        },
        onOkEseguiAttivita() {
            let me = this;
            me.attivitaSelezionata.stato = "ESEGUITO";
            me.attivitaSelezionata.statoIntervento = "ESEGUITO";
            me.saveIntervento();
        },
        onCancelEseguiAttivita() {
            let me = this;
            me.attivitaSelezionata = {};
        },
        saveIntervento() {
            let me = this;
            // me.$refs.mdlSaModalLoading.show();
            UtilityMixin.methods.saveResource(me.pathResource, me.attivitaSelezionata, me.saveSucessResponse, me.saveErrorResponse);
        },
        saveSucessResponse(response) {
            response;
            this.$bvToast.toast("Salvataggio Avvenuto con successo!", {
                title: "",
                variant: "success",
                solid: true,
            });
        },
        saveErrorResponse(error) {
            error;
            if (error.response.status === 400) {
                this.$bvToast.toast("Errore: " + error.response.data.messaggio, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
                this.$emit("errorRestCall", error);
                // me.$refs.mdlSaModalLoading.close();
            } else {
                this.$bvToast.toast("Errore nel salvare i dati del Piano: " + error.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
                // me.$refs.mdlSaModalLoading.close();
            }
        },
    },
};
</script>

<style scoped>
/* Card Pratica */
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}

/* Sezione Prestazioni */
.sa-siat-prestazione-item {
    border: 1px solid #e2e8f0;
    margin: 8px 20px;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s ease;
}

.sa-siat-prestazione-header {
    padding: 12px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sa-siat-prestazione-header:hover {
    background: #f8fafc;
}

/* Colori per Figura */
.sa-siat-border-IP {
    border-left: 5px solid #3498db;
}

.sa-siat-border-FISIO {
    border-left: 5px solid #2ecc71;
}

.sa-siat-border-OSS {
    border-left: 5px solid #e67e22;
}

.sa-siat-border-PSIC {
    border-left: 5px solid #9b59b6;
}

.sa-siat-border-MED {
    border-left: 5px solid #e74c3c;
}

.sa-siat-text-IP {
    color: #3498db !important;
}

.sa-siat-text-FISIO {
    color: #2ecc71 !important;
}

.sa-siat-text-OSS {
    color: #e67e22 !important;
}

.sa-siat-text-PSIC {
    color: #9b59b6 !important;
}

.sa-siat-text-MED {
    color: #e74c3c !important;
}

.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.95rem;
}

.sa-siat-valore-pai {
    color: #2c3e50;
    font-weight: 600;
}

.sa-siat-row {
}

.sa-siat-cols {
    padding-right: 25px;
    padding-left: 25px;
}

.sa-siat-text-data {
    color: #c20000;
}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}

.sa-siat-data {
    color: #e83e8c;
}

.sa-siat-badge {
    display: block;
    font-size: 1rem;
    max-width: 150px;
}

.sa-siat-badge-aperta {
    color: #07af07;
}

.sa-siat-badge-da-programmare {
    color: #e67e22;
}

.sa-siat-data-complesso {
    color: #e67e22;
}
</style>
